import { Analytic } from "src/analytic/analytic";
import { OneSignalHelpers } from "./helpers";
import { oneSignal } from "./lib";
import { InitCordovaCallbacks, OneSignalUserTags, SelfNotification } from "./models";

export class OneSignal {
    static readonly appId = process.env.REACT_APP_ONESIGNAL_APP_ID
        ? process.env.REACT_APP_ONESIGNAL_APP_ID
        : undefined;
    static readonly isEnabled = !!OneSignal.appId;

    static init(promptMsg?: string, callbacks?: InitCordovaCallbacks) {
        if (!OneSignal.isEnabled) {
            return console.log("one signal disabled");
        }

        const isOneSingleCall = !!localStorage.getItem("isOneSingleCall");
        if (!isOneSingleCall) {
            localStorage.setItem("isOneSingleCall", "1");
            if (!OneSignal.isEnabled) {
                return console.log("one signal disabled");
            }

            const isSupported = OneSignalHelpers.isPushNotificationsSupported();
            if (!isSupported) {
                Analytic.addEvent({
                    event: "push_notification_not_supported",
                    defaultGTMConfig: "true",
                });
            }

            OneSignalHelpers.initWebApp({
                promptMsg:
                    promptMsg || "Always Be Heard. Never miss a FlashPoll. No spam - we promise.",
                welcomeNotificationMsg: "We heartily welcome you to Flashmob!",
            });

            OneSignalHelpers.setupEventListeners();
        }
    }

    static setSubscription = async (status: boolean) => {
        if (!OneSignal.isEnabled) return;
        const playerId = await OneSignalHelpers.getPlayerId();
        if (playerId) {
            // https://documentation.onesignal.com/docs/web-push-sdk#section--setsubscription-
            oneSignal().push(["setSubscription", status]);
            OneSignalHelpers.onSubscriptionChange(status);
        } else {
            console.error({
                message: "missing player id. cannot set subscription to " + status,
            });
        }
    };

    //Showing the permission prompt would automatically trigger the subscription change event
    static showNotificationPermissionPrompt = () => {
        if (!OneSignal.isEnabled) return;
        oneSignal().push(() => {
            oneSignal()
                .showHttpPrompt()
                .catch((e: Error) => {
                    console.error({ message: e.message });
                });
        });
    };

    static saveTags = (tags: OneSignalUserTags) => {
        if (!OneSignal.isEnabled) return;
        oneSignal().push(() => {
            oneSignal()
                .sendTags(tags)
                .catch((e: Error) => {
                    console.error({
                        message: `error saving user tags to one signal ${e.message}`,
                    });
                });
        });
    };

    static sendSelfNotification = (payload: SelfNotification) => {
        if (!OneSignal.isEnabled) return;
        oneSignal().sendSelfNotification(
            payload.title,
            payload.message,
            payload.webUrl,
            payload.notificationLogo,
            payload.additionalData
        );
    };
}
